<template>
  <div>
    <div class="card-header" @click="open = !open">
      <div class="line-info">
        <div class="room-name">
          <span>{{ order.room.name || order.room.roomType }}</span>
        </div>
        <img
          class="brand-logo"
          :src="order.room.line.brand_logo"
          alt="brand_logo"
        />
        <span class="title">{{ order.room.line.name }}</span>
      </div>
      <div class="price-dropdown-container">
        <div class="price">
          <TweenPrice
            :price="vatPrice(totalDiscountedPriceInMinorUnits / 100)"
          />
        </div>
        <img
          class="arrow"
          :class="{ open }"
          :src="getIcon('triangle.svg')"
          alt="arrow"
        />
      </div>
    </div>
    <transition @enter="enter" @leave="leave">
      <div class="card-body" v-if="open">
        <OrderSummaryCategory
          v-for="category in categories"
          :key="category.name"
          :category="category"
          :room="order.room.id"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import OrderSummaryCategory from '@/components/order/OrderSummaryCategory.vue';
import TweenPrice from '@/components/utilities/TweenPrice.vue';
import { mapGetters } from 'vuex';
import {
  getCategories,
  calculateTotalDiscountedPrice,
} from '@/services/orderUtils';

export default {
  name: 'OrderSummaryLine',
  components: { TweenPrice, OrderSummaryCategory },
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      open: true,
    };
  },
  computed: {
    ...mapGetters({
      calculateTotalPriceWithDiscount:
        'discount/calculateTotalPriceWithDiscount',
    }),
    categories() {
      return getCategories(this.order.productsWithAmount);
    },
    totalDiscountedPriceInMinorUnits() {
      return calculateTotalDiscountedPrice(
        [this.order],
        this.calculateTotalPriceWithDiscount
      );
    },
  },
  methods: {
    enter(el) {
      el.style.height = '0';
      el.style.opacity = '0';
      el.offsetHeight;
      el.style.transition = 'height 0.5s ease, opacity 0.5s ease';
      el.style.height = el.scrollHeight + 'px';
      el.style.opacity = '1';
    },
    leave(el) {
      el.style.height = el.scrollHeight + 'px';
      el.style.opacity = '1';
      el.offsetHeight;
      el.style.transition = 'height 0.5s ease, opacity 0.5s ease';
      el.style.height = '0';
      el.style.opacity = '0';
    },
  },
};
</script>
